import { format } from 'owa-strings/utilities/format';
import { ITEM_URL } from '../utils/constants';
import { makeSDSNetworkCall } from './makeSDSNetworkCall';

export function createSDSCollectionItem(collectionName: string, itemClass: string, body: any = {}) {
    return makeSDSNetworkCall(format(ITEM_URL, collectionName), 'POST', {
        ItemClass: itemClass,
        ...body,
    });
}
